<template>
  <span class="l-spacing-half" :loading="isLoading">
    {{ formatted }}
  </span>
</template>

<script>
export default {
  props: {
    formatted: {
      type: String,
      required: true
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  }
}
</script>
